export const baseUrl = "https://api.themoviedb.org/3";

export const API_KEY = "8ed4b1bc2a89ea85b6ee93daa4f230e9";

export const imageUrl = "https://image.tmdb.org/t/p/original";
